export default __webpack_public_path__ + "static/media/deflatonftmHLP.496534ea.png";